// extracted by mini-css-extract-plugin
export var btn = "Blog-module--btn--c2b85";
export var core = "Blog-module--core--7e8a5";
export var slide = "Blog-module--slide--00436";
export var slider = "Blog-module--slider--21be3";